import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HiChevronUp, HiChevronDown } from "react-icons/hi";

export const CompanyProfileNameOption = styled("div", {
  shouldForwardProp: (props) => props !== "displayChevron" && props !== "hasIcon",
})(({ displayChevron, hasIcon }: { displayChevron: boolean; hasIcon: boolean }) => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  color: "#465869",
  maxWidth: displayChevron ? "210px" : hasIcon ? "200px" : "240px",
  lineHeight: "21px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const ProfileCompany = styled(Grid)(() => ({
  marginTop: "12px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

export const UserCompanyLogo = styled("img")(() => ({
  width: "20px",
  height: "20px",
  borderRadius: "50%",
}));

export const ProfileCompanyOptionIconUp = styled(HiChevronUp)(() => ({
  marginLeft: "auto",
}));

export const ProfileCompanyOptionIconDown = styled(HiChevronDown)(() => ({
  marginLeft: "auto",
}));

export const CompanyAndProfileNameContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flexWrap: "nowrap",
}));

export const CompanyProfileName = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#667085",
}));
